export default __webpack_public_path__ + "static/media/facebookLogo.8d4c4dc2.svg";